import { cssNumber } from "jquery";

// ------ Header Searchform Toggle ------
$(".js-search-button").on("click", function (e) {
  if (window.matchMedia("(min-width: 1050px)").matches) {
    if (!$(".js-header-searchform").hasClass("js-opened")) {
      e.preventDefault();
      $(".js-header-searchform").addClass("js-opened");
      $(".js-header-searchform input").fadeIn(function() {
        $(".js-header-searchform input").focus();
      });
    }
  }
});

$(document).mouseup(function (e) {
  var $container = $(".js-header-searchform.js-opened");
  // if the target of the click isn't the container nor a descendant of the container
  if (
    window.matchMedia("(min-width: 1050px)").matches &&
    !$container.is(e.target) &&
    $container.has(e.target).length === 0
  ) {
    $container.removeClass("js-opened");
    $(".js-header-searchform input").fadeOut(300);
  }
});

// Notification message sessionStorage
$(".js-notification-message-btn").click(function () {
  // Hide notification
  $(this).parents('.js-notification-message').slideToggle();

  // Set sessionStorage with the element ID
  const notification_id = $(this).parents('.js-notification-message').attr("id");
  sessionStorage.setItem(notification_id, "hide");
});

$(document).ready(function () {
  // Notification message status check with sessionStorage
  $(".m-notification-message").each(function () {
    const notification_id = $(this).attr("id");

    if (sessionStorage.getItem(notification_id) === "hide") {
      $(this).hide();
    }
  });
});
